import script from "./Microbit.vue?vue&type=script&setup=true&lang=js"
export * from "./Microbit.vue?vue&type=script&setup=true&lang=js"

import "./Microbit.vue?vue&type=style&index=0&id=4968ad4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4968ad4b"]])

export default __exports__